<template>
  <Header></Header>

  <div class="app-container">

    <el-container>
      <el-header>
        <LogoBox></LogoBox>
        <MainMenu :menus="menus"></MainMenu>
      </el-header>

<!--      <el-main>
        <router-view></router-view>
      </el-main>-->
      <router-view></router-view>
    </el-container>

  </div>

  <Footer ref="footer" v-if="footerShow" :selectedActive="active"></Footer>
</template>

<script>
import api from './api/api'

import Header from "./components/Header";
import Footer from "./components/Footer";
import MainMenu from "./components/MainMenu";
import LogoBox from "./components/LogoBox";

export default {
  name: 'App',
  components: {
   Header,MainMenu,LogoBox,Footer
  },

  data(){
    return {
      content: null,
      //menus: undefined,
      footerShow: true,
      active:0,
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
    }
  },
  methods: {
    footer: function (bool,active=0) {
      this.footerShow = bool
      this.active = active
    }
  },
  async mounted() {
    let json = await api.common.index()
    this.content = json.data
  },
  created() {
    /*menu().then((response) => {
      const { data } = response
      this.menus = data
    })*/
  }
}
</script>

<style scoped>
.app-container{
  width: 1200px;
  margin: 0 auto;
  background-color: #fff;
}
/deep/.el-header ,/deep/.el-footer{
  height: auto;
  padding: 0;
  margin: 0;
}
/deep/.el-footer{
  background-color: #7d7d7f;
}
.el-main {
  padding: 0;
  margin: 0;
  overflow: unset;
}
.common-title .title{
  font-weight: bold;
  color: #ba0303;
}
.common-title .more{
  float: right;
  font-size: 12px;
  color: #5a5e66;
}
</style>